import { render } from "./i-download.vue?vue&type=template&id=2d7fc0de"
import script from "./i-download.vue?vue&type=script&lang=js"
export * from "./i-download.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__